import { Outlet } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { TalkToAyushFab } from "@/components/TalkToAyushFab";
import useLenis from "@/hooks/useLenis";

export default function Layout() {
  useLenis();
  return (
    <div className="grain min-h-screen bg-background">
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
      <TalkToAyushFab />
    </div>
  );
}
